import { render, staticRenderFns } from "./VueScriptComponent.vue?vue&type=template&id=10c699c7&"
import script from "./VueScriptComponent.vue?vue&type=script&lang=js&"
export * from "./VueScriptComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports